import { render, staticRenderFns } from "./ReportDetailTable.vue?vue&type=template&id=6f502f68&scoped=true&class=h-100%20w-100%20container-table"
import script from "./ReportDetailTable.vue?vue&type=script&lang=ts"
export * from "./ReportDetailTable.vue?vue&type=script&lang=ts"
import style0 from "./ReportDetailTable.vue?vue&type=style&index=0&id=6f502f68&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f502f68",
  null
  
)

export default component.exports